module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var person = Util.clone(value);

if (person.birthdate) {
	person.birthdate = Date.fromDate(value.birthdate).format("dd.mm.yyyy");
}

if (person.sex == Sex.Unknown) {
	delete person.sex;
}

Util.String.titleIf(person, {
	sex: Sex
});

card.encode(person, {
	name: "имя ",
	sex: "пол ",
	age: "возраст ",
	height: "рост ",
	birthdate: "д.р. ",
	comment: "комментарий ",
	phone: "телефон "
}, mode);

var items = [];

items.push(Util.String.join([person.name, person.sex, person.birthdate, person.age, person.height, person.phone]));
items.push(value.comment);

    ; __append("\n\n")
    ; __append(escapeFn( Util.String.join(items, "\n") ))
    ; __append("\n\n\n\n")
  }
  return __output.join("");

}